import QuoteMediaImageUploader from '@/components/quote-media-image-uploader/quote-media-image-uploader';
import { useFormContext } from 'react-hook-form';

/**
 * Media form for the Quote Summary page - Media Tab.
 * @file MediaForm.jsx
 * @returns {JSX.Element} The rendered Media Form component.
 */
const QuoteMediaForm = () => {
  const {
    formState: { isLoading: formLoading },
    setValue,
    getValues,
  } = useFormContext();

  const quote = getValues('quote');
  const gallery = [quote?.first_image, quote?.second_image, quote?.third_image];

  const userUploadedImage = {
    0: 'quote.first_image',
    1: 'quote.second_image',
    2: 'quote.third_image',
  };

  return (
    <div>
      {gallery?.map((item, index) => (
        <QuoteMediaImageUploader
          heading={`Image ${index + 1}`}
          name={`${userUploadedImage[index]}`}
          key={item?.order}
          loading={formLoading}
          setValue={setValue}
        />
      ))}
    </div>
  );
};

export default QuoteMediaForm;
